export function DesignPlaneData() {
    this.textureRotationAngle = 0;
    this.uuidProduct = '';
    this.texture = '';
    this.withShadow = true;
}